



















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Toast, Dialog, Popup } from 'vant';
import { save, ifSave, getBaseInfo, rank } from '../api';
import { isWeiXin } from '@/common/ts/common';
import qs from 'qs';
Vue.use(Toast).use(Dialog).use(Popup);
@Component
export default class InviteApply extends Vue {
  @Prop({
    default: 'http://count.cqcb.com/showDetail/47',
  })
  downLoadUrl!: string;
  baseInfo: any = {};
  pointOut = false;
  async created() {
    window.userInfoChange = () => {
      this.$router.go(0);
    };

    const resp: any = await getBaseInfo();
    if (resp.code === 200) {
      this.baseInfo = resp.data;
    }

    // const res: any = await ifSave();
    // const diff = this.baseInfo.endTime * 1000 > Date.now() && res.code === 203;
    // if (res.code === 200 || diff) {
    //   this.showApplyBtn = true;
    // } else {
    //   this.showApplyBtn = false;
    // }
  }
  async handleClickApply() {
    if (!window.udid) {
      this.tipDownloadApp();
      return;
    }
    if (window.gettoken() && window.gettoken() !== 'null') {
      // 判断当前报名时间
      const startT = this.baseInfo.startTime * 1000;
      const endT = this.baseInfo.endTime * 1000;
      const now = Date.now();
      if (now < startT) {
        Toast('报名未开始');
        return;
      }
      const id = qs.parse(location.search)[`?id`];
      const res: any = await save(id as string);
      Toast(res.msg);
      setTimeout(() => {
        this.$router.push({
          path: 'home',
        });
      }, 500);
    } else {
      this.inAppAlertLogin();
    }
  }
  inAppAlertLogin() {
    if (parseFloat(window.version) >= 4.5) {
      window.handleMessage('{"action":"mUserLogin","data":""}');
    } else {
      window.location.href = 'client:logout';
    }
  }
  tipDownloadApp() {
    Dialog.confirm({
      title: '友情提示',
      message: '请在上游新闻App进行报名',
      confirmButtonText: '还没装？一步安装',
      cancelButtonText: '我已安装过',
      closeOnClickOverlay: true,
    })
      .then(() => {
        window.location.href = this.downLoadUrl;
      })
      .catch(() => {
        if (isWeiXin() === true) {
          this.pointOut = true;
        } else {
          window.location.href =
            'shangyounews://{"dt":"7","url":"' + document.location.href + '"}';
        }
      });
  }
}
